module.exports = __webpack_public_path__ + "media/images/block-action-2x-9daaa37b.png";